<template>
  <div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-center"> <b>Asignar Categoria Moodle Programa</b> </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-center">
          <!-- <p> {{modulo}} </p> -->
          <small>Escriba el nombre de la categoria:</small>
          <p class="text-primary" style="margin-top:0"> <small>{{msg}}</small> </p>
          <multiselect class="form-control xinput input-group-sm" v-model="categoria" id="id" label="nombre" 
            track-by="id" placeholder="Ingrese el Nombre o documento (4 letras minimo)..." open-direction="bottom" 
            :options="datos" :multiple="false" :searchable="true" :loading="isLoading" :internal-search="false" 
            :clear-on-select="true" :close-on-select="true" :options-limit="300" :limit="15" :limit-text="limitText" 
            :max-height="600" :show-no-results="true" :hide-selected="false" :show-labels="false" @search-change="asyncFind">

            <template slot="tag" slot-scope="{ option, remove }"><span class="custom__tag"><span>{{ parseLabel(option) }}</span><span class="custom__remove" @click="remove(option)">❌</span></span></template>
            <template slot="clear" slot-scope="props">
              <div class="multiselect__clear" v-if="categoria==null" @mousedown.prevent.stop="clearAll(props.search)"></div>
            </template>
            <span slot="noResult">No se encontraron categorias con ese nombre</span>
          </multiselect>
        </div>
        
        <Alertas 
          ref="alertar" 
          v-bind:msgSuccess="'El cambio de estado se realizo satisfactoriamente.'"
          v-bind:msgLoading="'Aplicando...'"
        />
        <div class="modal-footer">
          <button @click="submit" v-if="activo" type="button" class="btn btn-azul">Aceptar</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import Alertas from '@/components/AAlertas.vue'
import {parseJsonError} from '@/components/Utils.js'

export default {
  props:{ modulo:{type:Object,required:true} },// {pid,ccid,tag}
  data(){
    return{
      timeoutHnd: 0,
      activo:true,
      isLoading: false,
      categoria:null,
      datos:[],
      msg:'',
    }
  },
  components:{ Alertas },
  methods:{
    limitText (count) { return `and ${count} other countries` },
    asyncFind( query ){
      if (this.timeoutHnd) { 
          clearTimeout(this.timeoutHnd);
          this.timeoutHnd = 0;
      }
      var vue = this;
      vue.msg = "Verificando...";
      this.timeoutHnd = setTimeout(function () {
        query = query.trim();
        if(query.length>3) {
          vue.buscar(query);
        }else{
          vue.msg = "";
        }
        vue.timeoutHnd = 0;
      }, 1200);      
    },
    buscar(query) {
      if( query.length <= 3 ) return;
      if( this.isLoading ) return;
      var vue = this;
      vue.isLoading = true;
      vue.datos = [];

      var cuerpo = {
        "data":{
          "filter":{
            "text": query,
            "visibility": 1
          }
        }
      };
      var data = JSON.stringify(cuerpo);
      var url = process.env.VUE_APP_URL_NOTIFIER_ESAM+"get-course-categories/";
      // window.console.log( "DATA> ",data );

      var config = { method: 'post', url: url,headers: { 'Content-Type': 'application/json' }, data : data };
      window.axios(config)
        .then(function (res) {
          var dts = [];
          res.data.categories.forEach( function(e){
            dts.push( {id:e.id,nombre:e.id+' - '+e.name,idnumber:e.idnumber,visible:e.visible} );
          });

          // window.console.log('------------ RESPUESTA DEL SERVIDOR ------------')
          // window.console.log( ">> ",window.stringifyObject(res),res )
          vue.isLoading = false;
          vue.msg = "";
          vue.datos = dts;
        })
        .catch(function (error) {
          window.console.error(error)
          vue.isLoading = false;
          vue.msg = "";
      });
    },
    submit(){
      if( !this.categoria ){
        return;
      }
      var vue = this;
      this.$refs.alertar.cargando();
      var input = { programa_id:this.modulo.pid,course_category_id:this.categoria.id };
      var sql = gql`mutation{ asignarCategoriaMoodle(input:${window.stringifyObject(input)}){ ok,programa{id},errors{message} } }`
      // window.console.log( sql );

      this.$apollo.mutate({
        mutation: sql,
      }).then((data) => {
        this.$refs.alertar.reset();
        var res = data.data.asignarCategoriaMoodle;
        // window.console.log( res )
        if( res.ok ){
          //this.modulo.tag.course_category_id = this.categoria.id;
          // window.console.log( "RES>> ",window.stringifyObject(vue.modulo.tag) )
          this.$emit( 'exito',this.categoria.id );
          window.$('#modal-categoria').modal('hide')
          //window.location.reload();
        }
        
      }).catch((error) => {
        vue.$refs.alertar.invalido();
        window.console.error(error)
        vue.isLoading = false;
        vue.msg = "...";
        vue.$notify( parseJsonError( error,'getEstudiantesByDoc' ) )
      })
    },
  }
}
</script>